import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sgBpsToRateGroup',
  standalone: false,
})
export class SgBpsToRateGroupPipe implements PipeTransform {
  /**
   * Converts lending rate in BPS to the respective rate group
   * @param value The BPS value
   */
  transform(value: number): string {
    return SgBpsToRateGroupPipe.transform(value);
  }

  static transform(value: number): string {
    if (value < 100) return 'GC';
    if (value < 400) return 'Special';
    return 'Deep Special';
  }
}
